import GamePlay from "@/views/GamePlay";
import ChallengeFriend from "@/views/ChallengeFriend";

export default [
    {
        path: "/game-play/:id",
        name: "GamePlay",
        component: GamePlay,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/challenge-friend",
        name: "ChallengeFriend",
        component: ChallengeFriend,
        meta: {
            requiresAuth: true
        }
    }
];
